import SleepTracking from '../sections/sleepTracking/sleepTracking';

export default function SleepPage() {
  return (
    <div className="section-page">
      <SleepTracking />
    </div>
  );
}
